export default __webpack_public_path__ + "static/media/chrome.ee865471.svg";